'use es6';

import { MEETINGS_USER_VIEWED_PAYMENT_BANNER } from '../constants/userAttributeKeys';
const createAttributeSelector = key => state => {
  const attributes = state.userAttributes.attributes;
  const attributeValue = attributes.get(key);
  return attributeValue === 'true' || attributeValue === true;
};
export const paidMeetingsBannerSelector = createAttributeSelector(MEETINGS_USER_VIEWED_PAYMENT_BANNER);